import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";


const GetAllUsers = (value, searchType) => {
    const v = String(value ?? "").trim();
    const enabled =
        searchType === "contact_no"
            ? /^\d{10}$/.test(v)
            : v.length >= 2;

    return useQuery(
        ["get-all-users", value, searchType],
        () =>
            request({
                url: `user/admin`,
                method: "GET",
                params:
                    searchType === "name"
                        ? { name: value }
                        : { contact_no: value },
            }),
        { enabled }
    );
};

export default GetAllUsers;